/* eslint-disable import/extensions */
import * as Papa from 'papaparse';
import {type IProject} from '@unbrs/plastic-data/src/brs';
import {BrsBaseWidget} from '../base';
import html from './views/project-view.tmpl.html';
import {BrsPlasticProjectWidget} from './project';

BrsBaseWidget.registerBrsWidget(BrsPlasticProjectWidget);
export type BrsPlasticProjectsWidgetOptions = {
	dataSource?: kendo.data.DataSource;
	height?: string;
	pageable?: boolean;
};

export class BrsPlasticProjectsWidget extends BrsBaseWidget {
	public override options: Record<string, unknown> = {
		name: 'brsplasticprojectswidget',
	};

	private dataSource?: kendo.data.DataSource;
	private readonly listDataSource: kendo.data.DataSource;
	private readonly listView: kendo.ui.ListView;
	private readonly exportCsvButton: JQuery;
	constructor(selector: Element, options: BrsPlasticProjectsWidgetOptions) {
		super(selector, options);
		options = Object.assign({
			pageable: true,
		}, options);

		if (options?.dataSource) {
			this.setDataSource(options.dataSource);
		}

		this.element.html(html);
		this.listDataSource = new kendo.data.DataSource({
			serverPaging: false,
		});
		this.exportCsvButton = $('.brs-projects-export-csv', this.element).hide();
		this.exportCsvButton.on('click', this.exportToCsv.bind(this));

		if (options.pageable) {
			this.listDataSource.pageSize(20);
		}

		const listelem = $('.brs-projects-list', this.element);
		this.listView = listelem.kendoListView({
			autoBind: false,
			dataSource: this.listDataSource,
			template: () => '<div class="k-listview-item collapsible"></div>',
			pageable: options.pageable,
			dataBound(event) {
				$('.k-listview-item', event.sender.element).each((i, element) => {
					$(element).kendoBrsPlasticProjectWidget({
						project: event.sender.dataSource.view()[i] as IProject,
					});
				});
			},
		}).data('kendoListView');

		this.height(options?.height ?? 'auto');

		this.listDataSource.bind('change', this.refreshPanelBar.bind(this));
	}

	preprocessForCsv(data: any[]): Array<Record<string, string>> {
		const result = [];
		for (const project of data as IProject[]) {
			const rec: Record<string, string> = {};
			const entries = Object.entries(project);
			if (project.isGlobal === undefined) {
				entries.push(['isGlobal', false]);
			}

			for (const [k, v] of entries) {
				if (k === 'isUmbrella') {
					continue;
				}

				if (v instanceof Date) {
					rec[k] = v.toISOString().split('T')[0]!;
					continue;
				}

				if (Array.isArray(v) && v.length > 0 && Object.hasOwn(v[0] as Record<string, unknown>, 'name')) {
					// eslint-disable-next-line @typescript-eslint/no-unsafe-return
					rec[k] = v.map((item: any) => item.name).join(', ');
					continue;
				}

				rec[k] = v as string;
			}

			result.push(rec);
		}

		return result;
	}

	exportToCsv() {
		const data = this.preprocessForCsv(this.listDataSource.data().toJSON());
		if (data.length === 0) {
			console.error('No data available to export.');
			return;
		}

		const csvContent = Papa.unparse(data, {
			delimiter: ';',
		});

		const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
		const link = document.createElement('a');
		const url = URL.createObjectURL(blob);

		link.setAttribute('href', url);
		link.setAttribute('download', 'export.csv');
		link.style.visibility = 'hidden';
		document.body.append(link);
		link.click();
		link.remove();
	}

	refreshPanelBar(event: kendo.data.DataSourceChangeEvent) {
		this.exportCsvButton.toggle(Boolean(event.items?.length));

		if (!this.listView.content) {
			return;
		}

		this.listView.content.data('kendoPanelBar')?.destroy();

		// TODO(a.mazurov): Why it was hidden?
		this.listView.element.find('.k-pager-info').show();
		this.listView.content.kendoPanelBar(
			{
				collapse(event: kendo.ui.PanelBarExpandEvent) {
					if (event.item) {
						$(event.item).find('>span').removeClass('k-selected');
					}
				},
			},
		);
	}

	refresh(event: {items: IProject[]}) {
		if (event.items) {
			// Don't show umbrella projects
			this.listDataSource.data(event.items.filter(item => !item.isUmbrella));
			if (this.listDataSource.page() && this.listDataSource.page() !== 1) {
				this.listDataSource.page(1);
			}
		}
	}

	setDataSource(dataSource: kendo.data.DataSource | IProject[]) {
		if (Array.isArray(dataSource)) {
			this.dataSource = new kendo.data.DataSource({
				data: dataSource,
			});
			this.refresh({items: dataSource});
		} else {
			this.dataSource = dataSource;
			this.dataSource.bind('change', this.refresh.bind(this));
		}
	}

	height(height?: string): string | void {
		const element = $('.k-listview-content', this.element);
		if (height) {
			element.css('height', height);
		} else {
			return element.css('height');
		}
	}
}

declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface JQuery {
		kendoBrsPlasticProjectsWidget(options?: BrsPlasticProjectsWidgetOptions): JQuery;
		data(widgetName: 'kendoBrsPlasticProjectsWidget'): BrsPlasticProjectsWidget;
	}
}

BrsBaseWidget.registerBrsWidget(
	BrsPlasticProjectsWidget,
	'BrsPlasticProjectsWidget',
);
